import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store/redux';
import { selectIsAuthenticated } from '@/store/redux/slices/authSlice';
import { ROUTES } from '../config';

interface PublicRouteProps {
  children: ReactNode;
}

/**
 * Route guard for public pages (login/register)
 * Redirects to dashboard if already authenticated
 */
export const PublicRoute = ({ children }: PublicRouteProps) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    console.log('[PublicRoute] User already authenticated, redirecting to dashboard');
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
